/* eslint-disable */
import { FaUserCircle } from 'react-icons/fa';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 16px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  min-width: 600px;
`;


export const Image = styled.img`
  height: 106px;
  width: 106px;
  border-radius: 53px;
`;

export const UserIcon = styled(FaUserCircle)`
  height: 106px;
  width: 106px;
  color: #b0b0b0;
  border-radius: 53px;
`;

export const RowAlign = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const RowSpace = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;

  width: 100%;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 180px;
`;

export const Title = styled.p`
  font-size: 20px;
  font-family: Inter;
  color: #000;
  line-height: 22px;
`;

export const Text = styled.p`
  font-size: 12px;
  font-family: Inter;
  color: #333;
  line-height: 18px;
`;

export const LightText = styled.p`
  font-size: 12px;
  font-family: Inter;
  color: #696969;
  line-height: 14px;
`;

export const Content = styled.div`
display: flex;
flex-direction: column;
  padding: 0 0 0 32px;;

  flex: 1;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px;
`;

export const SiglaBadge = styled.div`
  display: flex;
  padding: 4px 6px 4px 6px;
  min-width: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  background-color: #f0f0f0;
  margin: 0 0 0 8px;
`;

export const SiglaText = styled.p`
  font-size: 11px;
  font-family: 'Graphik-Regular';
  color: #333333;
`;


export const TypeText = styled.p`
  font-size: 12px;
  font-family: Inter;
  color: #000;
`;